import { render, staticRenderFns } from "./MassAddSuccess.vue?vue&type=template&id=2da2ef14&scoped=true&"
import script from "./MassAddSuccess.vue?vue&type=script&lang=js&"
export * from "./MassAddSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da2ef14",
  null
  
)

export default component.exports